module.exports = __webpack_public_path__ + "static/Group 9-f00b85ff69edae89643d7b1d788e49f4.png";